export const fieldList = {
  columnKeys() {
    const returnArray = (new Array(6)).fill().map((nothing, index) => ({ key: `num${index + 1}`, label: `${index + 1}` }))
    returnArray.push({
      key: 'daxiao_da',
      label: '大'
    })
    returnArray.push({
      key: 'daxiao_xiao',
      label: '小'
    })
    return returnArray
  }
}
